import { render, staticRenderFns } from "./ChangeStatus.vue?vue&type=template&id=0aff99f0&"
import script from "./ChangeStatus.vue?vue&type=script&lang=ts&"
export * from "./ChangeStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports